import { render, staticRenderFns } from "./BasicInfoCard.vue?vue&type=template&id=125823c0&scoped=true"
import script from "./BasicInfoCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoCard.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoCard.vue?vue&type=style&index=0&id=125823c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125823c0",
  null
  
)

export default component.exports